import { RootState } from "store";

export const getUserDevices = (state: RootState) => state.userDevices;

export const getUserAudioInputDevices = (state: RootState) =>
  //@ts-ignore
  state.userDevices.devices.filter((device) => device.kind === "audioinput");
